import {
	EVENT_ACTION_REWARD_OFFERS_CANCEL_OFFER,
	EVENT_CATEGORY_ROYALTY_KPI,
} from '../../../../shared/analytics';
import { trackCustomEvent } from '../../../../shared/analytics/event/trackCustomEvent';

export function trackCancelRewardOffer(id: string) {
	trackCustomEvent({
		category: EVENT_CATEGORY_ROYALTY_KPI,
		action: EVENT_ACTION_REWARD_OFFERS_CANCEL_OFFER,
		id,
	});
}
